import { loadStripe } from "@stripe/stripe-js";

// One Stripe.js instance for the whole app (checkout page, Add billing).
// The live key is the fallback; local test mode sets REACT_APP_STRIPE_PUBLISHABLE_KEY.
export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    "pk_live_51RD0PIHVT97b1nEmemlvpOnBp7tl6oZqJGkzajpMWIqs7F2tvp7eSiRXArBaChnXCqOJKwaHSGaHopIctPsmOnGz00mVwptY14"
);
